module.exports = __webpack_public_path__ + "resources/sass/fn/fonts/OpenSans-ExtraBoldItalic-webfont.woff";


//////////////////
// WEBPACK FOOTER
// ./src/resources/sass/fn/fonts/OpenSans-ExtraBoldItalic-webfont.woff
// module id = 382
// module chunks = 0